// DO NOT MODIFY! THIS FILE IS AUTOGENERATED BY generate-endpoint-spec.util.ts

import { RequestHandler } from 'express';

export const TSpecRoute_postApproveAttendanceBonus = (path: TSpecPathPostApproveAttendanceBonus) => {
  let res = "/attendance-bonus/:id/approve";
  Object.entries(path).map(([key, value]) => {
    res = res.replace(':' + key, value);
  });
  return res;
};

export type TSpecHandler_postApproveAttendanceBonus = RequestHandler<TSpecPathPostApproveAttendanceBonus, any, TSpecBodyPostApproveAttendanceBonus, TSpecQueryPostApproveAttendanceBonus, {}>;

export interface TSpecPathPostApproveAttendanceBonus { id: string; }

export interface TSpecBodyPostApproveAttendanceBonus {}

export interface TSpecQueryPostApproveAttendanceBonus {
  AppVersion?: string;
  AppUser?: string;
}
